var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"salaries-content-delimiter"},[_vm._l((_vm.elements),function(element,i){return [_c('div',{key:i,staticClass:"salaries-content-delimiter__element"},[_c('div',[_vm._v(_vm._s(element))]),_vm._v(" "),_c('ArrowDelimiterSvg',{staticClass:"salaries-content-delimiter__element-icon"})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }